module.exports = __webpack_public_path__ + "static/media/history-books.84cd7bb3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/history-books.jpg
// module id = 190
// module chunks = 0